var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreenTickCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.948 4.11462C19.3627 4.7001 13.1597 7.62581 8.39015 12.3958C-2.79672 23.5842 -2.79672 41.4204 8.39015 52.6088C19.577 63.7971 37.411 63.7971 48.5979 52.6088C53.4385 47.7675 56.295 41.6451 56.8878 34.8411C57.0695 32.7549 57.041 32.1798 56.7248 31.5496C56.3822 30.8671 55.8374 30.4815 55.1178 30.4123C54.1552 30.3199 53.2405 30.8113 52.912 31.5976C52.8148 31.8303 52.7113 32.6741 52.6516 33.7188C52.4501 37.2514 51.75 39.9526 50.2104 43.1382C47.2176 49.3307 41.1705 54.2717 34.5408 55.9418C32.173 56.5381 31.5142 56.6111 28.494 56.6111C25.4738 56.6111 24.815 56.5381 22.4472 55.9418C14.1387 53.8489 7.1502 46.8595 5.05759 38.5498C4.46127 36.1818 4.38834 35.5229 4.38834 32.5023C4.38834 29.4817 4.46127 28.8228 5.05759 26.4547C6.72738 19.8242 11.6678 13.7763 17.8595 10.7831C21.0447 9.24325 23.7455 8.54306 27.2777 8.34159C28.3222 8.2819 29.1659 8.17832 29.3986 8.0811C30.1847 7.75255 30.6761 6.83775 30.5837 5.87506C30.5146 5.15538 30.1289 4.61044 29.4465 4.26787C28.8385 3.9626 28.0476 3.92796 25.948 4.11462Z",
    fill: "#07B055"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.667 30.3333L27.0003 39.6666L50.3337 16.3333",
    stroke: "#07B055",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickCircle);
export default __webpack_public_path__ + "static/media/greenTickCircle.5191b183813579e598202647d122eac4.svg";
export { ForwardRef as ReactComponent };